<!-- @format -->
<template>
    <component
        :is="computedComponents"
        :booking="booking"
        :booking-hotel="bookingHotel"
        :booking-hotel-room="bookingHotelRoom"
        :selected-order="getHotelSelection"></component>
</template>

<script>
import { mapGetters } from 'vuex';
import ManageBookingCheckoutReplace from '@tenant/app/modules/hotel/features/manageBooking/TheManageBookingCheckout/ManageBookingCheckoutReplace';
import ManageBookingCheckoutRefund from '@tenant/app/modules/hotel/features/manageBooking/TheManageBookingCheckout/ManageBookingCheckoutRefund';

export default {
    name: 'TheManageBookingCheckout',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBookingCheckout',
    },
    testIdOptions: {
        keyPrefix: 'manageBookingCheckout',
    },
    computed: {
        ...mapGetters({
            booking: 'booking/get',
            bookingHotel: 'booking/getHotel',
            bookingHotelRoom: 'booking/getRoom',
            getHotelSelection: 'orderSelection/getHotelSelection',
        }),
        computedComponents() {
            return this.$route.name === 'booking.replace.checkout'
                ? ManageBookingCheckoutReplace
                : ManageBookingCheckoutRefund;
        },
    },
};
</script>
